import React from "react";
import {InputContainer} from "../styles/InputContainer";
import PropTypes from "prop-types";

const TextArea = React.forwardRef(({ label, id, errorMessage, ...attrs }, ref) => {
	return (
		<InputContainer>
			{label && <label htmlFor={id}>{label}</label>}
			<textarea {...attrs} ref={ref} id={id} className={errorMessage && 'input-error'} />
			{errorMessage && <span role="alert">{errorMessage}</span>}
		</InputContainer>
	)
});

TextArea.displayName = 'TextArea';

TextArea.propTypes = {
	label: PropTypes.string,
	id: PropTypes.string,
	errorMessage: PropTypes.string,
};

export default TextArea;